var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import MenuItem from './micro/menuItem';
import IconItem from './micro/IconItem';
import './subfooter.scss';
var SubfooterData = {
    menuItems: [
        {
            label: 'Privacy',
            url: '/',
        },
        {
            label: 'Fraud Awareness',
            url: '/',
        },
        {
            label: 'Data Promise',
            url: '/',
        },
        {
            label: 'Legal',
            url: '/',
        },
        {
            label: 'Business Continuity',
            url: '/',
        },
        {
            label: 'Security',
            url: '/',
        },
        {
            label: 'Social',
            url: '/',
        },
    ],
    iconItems: [
        {
            label: 'Facebook',
            url: '/',
        },
        {
            label: 'Twitter',
            url: '/',
        },
        {
            label: 'LinkedIn',
            url: '/',
        },
    ],
};
var SubFooter = function (props) {
    var data = (props === null || props === void 0 ? void 0 : props.data) || SubfooterData;
    var menuItems = data.menuItems, iconItems = data.iconItems;
    var _a = useState(window.innerWidth), width = _a[0], setWidth = _a[1];
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(function () {
        window.addEventListener('resize', handleWindowSizeChange);
        return function () {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);
    var isTablet = width >= 768 && width < 1140;
    var renderMenuItems = function (menuItemsArray) {
        return menuItemsArray.map(function (menuItem, index) { return (_jsx("div", { children: _jsx(MenuItem, { menuItem: menuItem, index: index }, void 0) }, index)); });
    };
    var renderIconItems = function (iconItemsArray) {
        return iconItemsArray.map(function (iconItem, index) { return (_jsx("div", { children: _jsx(IconItem, { iconItem: iconItem, index: index }, void 0) }, index)); });
    };
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "subfooter mg:block min-w-screen z-50 w-full flex-nowrap items-center  justify-between footer-white-border py-12 md:py-5 lg:flex" }, { children: [menuItems !== undefined && (_jsxs("div", __assign({ className: "subfooter__menu-items block space-y-2 md:mx-auto md:flex md:w-full md:justify-between md:space-x-2 md:space-y-0 lg:w-2/3 lg:space-x-4 " + (isTablet ? '__tablet' : '') }, { children: [renderMenuItems(menuItems), isTablet && iconItems !== undefined && (_jsx("div", __assign({ className: "subfooter__social-icon-container__tablet my-5 flex space-x-2 md:my-4 md:w-full md:justify-start lg:my-0 lg:w-1/3 lg:justify-end " }, { children: renderIconItems(iconItems) }), void 0))] }), void 0)),
                !isTablet && iconItems !== undefined && (_jsx("div", __assign({ className: "subfooter__social-icon-container my-5 flex space-x-2 md:my-4 md:w-full md:justify-start lg:my-0 lg:w-1/3 lg:justify-end " }, { children: renderIconItems(iconItems) }), void 0))] }), void 0) }, void 0));
};
export default SubFooter;
